module.exports = {
  HBL: 'หมายเลขใบแจ้งหนี้นำเข้า',
  SONO: 'SONO (โซโน)',
  UserDefinedField1: 'ฟิลด์กำหนดเอง 1',
  UserDefinedField2: 'ฟิลด์กำหนดเอง 2',
  UserDefinedField3: 'ฟิลด์กำหนดเอง 3',
  UserDefinedField4: 'ฟิลด์กำหนดเอง 4',
  accordingToBusiness: 'ตามธุรกิจ',
  accordingToCharge: 'ตามค่าใช้จ่าย',
  accountStatementNo: 'หมายเลขใบแจ้งยอด',
  accrued: 'ได้บันทึกแล้ว',
  addCharge: 'เพิ่มค่าใช้จ่าย',
  adjustedOrNot: 'ปรับหรือไม่',
  advanceMoneyOrNot: 'จ่ายแทนหรือไม่',
  airExport: 'ส่งออกทางอากาศ',
  airImport: 'นำเข้าทางอากาศ',
  all: 'ทั้งหมด',
  amount: 'จำนวนเงิน',
  amountNotWrittenOff: 'จำนวนเงินที่ยังไม่ได้ชำระ',
  amountRange: 'ช่วงจำนวนเงิน',
  applicant: 'ผู้ขอ',
  applicationNo: 'หมายเลขใบขอ',
  applicationStatus: 'สถานะการขอ',
  appliedForPaymentOrNot: 'ได้ขอชำระเงินหรือไม่',
  approval: 'อนุมัติแล้ว',
  auditor: 'ผู้ตรวจสอบ',
  awaitBusinessApproval: 'รออนุมัติธุรกิจ',
  awaitFinancialApproval: 'รออนุมัติการเงิน',
  NosubmitWeaver: 'รอส่งไปยังแพลตฟอร์มคลาวด์',
  WeaverApproving: 'กำลังอนุมัติบนแพลตฟอร์มคลาวด์',
  WeaverApproved: 'อนุมัติบนแพลตฟอร์มคลาวด์แล้ว',
  back: 'ขั้นตอนก่อนหน้า',
  bankAccount: 'เลขที่บัญชีธนาคาร',
  bankOfDeposit: 'ธนาคารที่เปิดบัญชี',
  billNo: 'หมายเลขบิล',
  billPaymentNo: 'หมายเลขใบขอชำระเงิน',
  bookingNo: 'หมายเลขการจอง',
  businessApproval: 'การอนุมัติธุรกิจ',
  officeApproval: 'การอนุมัติทางธุรกิจ',
  businessCreateDate: 'วันที่สร้างธุรกิจ',
  businessDate: 'วันที่ธุรกิจ',
  businessNumber: 'เลขที่ธุรกิจ',
  businessReferenceNumber: 'หมายเลขอ้างอิงธุรกิจ',
  businessStatus: 'สถานะธุรกิจ',
  businessType: 'ประเภทธุรกิจ',
  bySettlementAgent: 'ผ่านตัวแทนชำระเงิน',
  cancel: 'ยกเลิก',
  cancelPartialWriteOff: 'ยกเลิกการชำระเงินบางส่วน',
  carrier: 'บริษัทขนส่ง',
  carrierId: 'บริษัทขนส่ง',
  chargeItem: 'ชื่อค่าใช้จ่าย',
  chargeOriginalAmount: 'จำนวนเงินเดิมของค่าใช้จ่าย',
  chargeOriginalCurrency: 'สกุลเงินเดิมของค่าใช้จ่าย',
  chargeOriginalExchangeRate: 'อัตราแลกเปลี่ยนเดิมของค่าใช้จ่าย',
  chargeRemark: 'หมายเหตุค่าใช้จ่าย',
  collectInvoice: 'รับใบแจ้งหนี้',
  confirmDate: 'วันที่ยืนยัน',
  confirmRemarks: 'หมายเหตุการยืนยัน',
  confirmUser: 'ผู้ยืนยันค่าใช้จ่าย',
  confirmationStatus: 'สถานะการยืนยัน',
  consignationCompany: 'หน่วยงานที่มอบหมาย',
  contactPerson: 'ผู้ติดต่อ',
  containerNo: 'หมายเลขตู้',
  containerSizeAmount: 'ประเภทตู้/ปริมาณตู้',
  controlledOrNot: 'อยู่ภายใต้การควบคุมหรือไม่',
  couldNotSearhWriteOffJobFromThisWindow: 'หมายเหตุ: หน้านี้ได้กรองค่าใช้จ่าย/ธุรกิจที่ถูกตัดจ่ายทั้งหมดแล้ว',
  creator: 'ผู้สร้าง',
  currency: 'สกุลเงิน',
  customJobType: 'ประเภทธุรกิจที่กำหนดเอง',
  customer: 'ลูกค้า',
  customerContact: 'ผู้ติดต่อธุรกิจ',
  customerService: 'บริการลูกค้า',
  dateOfApplication: 'วันที่สมัคร',
  dateOfCreation: 'วันที่สร้าง',
  delete: 'ลบ',
  department: 'แผนก',
  departmentApproval: 'การอนุมัติแผนก',
  destinationAgent: 'ตัวแทนท่าเรือปลายทาง',
  domesticInternational: 'ในประเทศ/ต่างประเทศ',
  edit: 'แก้ไข',
  edit2: 'แก้ไข',
  eta: 'เวลาถึงโดยประมาณ',
  etd: 'เวลาออกโดยประมาณ',
  atd: 'เวลาออกจริง',
  ata: 'เวลาถึงจริง',
  exchangeRate: 'อัตราแลกเปลี่ยน',
  export: 'ส่งออก',
  exportExcel: 'ส่งออก Excel',
  exportPDF: 'ส่งออก PDF',
  feeStatus: 'สถานะค่าใช้จ่าย',
  financialApproval: 'การอนุมัติทางการเงิน',
  financialAudit: 'การตรวจสอบทางการเงิน',
  financialDate: 'วันที่ทางการเงิน',
  generatedBillsOrNot: 'สร้างใบแจ้งหนี้แล้วหรือไม่',
  import: 'นำเข้า',
  importhbl: 'หมายเลขแบ่งนำเข้า',
  includeReceivables: 'รวมถึงลูกหนี้',
  inputBy: 'ผู้สร้างค่าใช้จ่าย',
  inquiryWay: 'วิธีการค้นหา',
  invalid: 'ยกเลิก',
  invoiceDate: 'วันที่ออกใบแจ้งหนี้ลูกหนี้',
  invoiceDateAll: 'วันที่ออกใบแจ้งหนี้',
  invoiceHeader: 'ชื่อผู้รับใบแจ้งหนี้',
  sellerInvoiceTitle: 'Seller invoice title',
  dateModified: 'เวลาเปลี่ยนแปลง',
  modifiedBy: 'ผู้เปลี่ยนแปลง',
  invoiceNo: 'เลขที่ใบแจ้งหนี้',
  invoiceState: 'สถานะใบแจ้งหนี้ที่ต้องรับ',
  invoicedOrNot: 'ออกใบแจ้งหนี้แล้วหรือไม่',
  invoicingMethod: 'วิธีการออกใบแจ้งหนี้',
  isNeedInvoice: 'จำเป็นต้องออกใบแจ้งหนี้หรือไม่',
  isReceivable: 'ประเภทรายรับรายจ่าย',
  itemNo: 'เลขที่โครงการ',
  lclMasterOrNot: 'เป็นใบเสร็จเล็กหรือไม่',
  masterFlagOrNot: 'เป็นใบเสร็จหลักหรือไม่',
  mbl: 'เลขที่เอกสารหลัก',
  methodOfPayment: 'วิธีการชำระเงิน',
  monetaryEquivalent: 'จำนวนเงินที่คำนวณ',
  needInvoice: 'จำเป็นต้องออกใบแจ้งหนี้หรือไม่',
  new: 'เพิ่มใหม่',
  newActualPayment: 'เพิ่มการชำระจริง',
  newActualReceipt: 'เพิ่มการรับจริง',
  newPaymentRequest: 'สร้างคำขอชำระเงิน',
  changePaymentRequest: 'แก้ไขคำขอชำระเงิน',
  deletePaymentRequest: 'ลบคำขอ',
  submintPaymentRequest: 'ส่งคำขอ',
  next: 'ขั้นตอนต่อไป',
  notSubmitted: 'ยังไม่ได้ส่ง',
  oceanExport: 'ส่งออกทางทะเล',
  oceanImport: 'นำเข้าทางทะเล',
  operation: 'ดำเนินการ',
  originalAmount: 'จำนวนเงินเดิม',
  payReceiveDate: 'วันที่รับ/จ่าย',
  payables: 'ต้องจ่าย',
  payment: 'การชำระเงิน',
  paymentDate: 'วันที่ชำระเงิน',
  paymentPeriod: 'ระยะเวลาชำระเงิน',
  paymentPeriodUnit: 'หน่วยระยะเวลาชำระเงิน',
  paymentType: 'ประเภทการชำระเงิน',
  planner: 'ผู้รับผิดชอบเส้นทาง',
  portOfDestination: 'ท่าปลายทาง',
  portOfDestinationAirport: 'ท่าปลายทาง(ทางอากาศ)',
  portOfDestinationSeaport: 'ท่าปลายทาง(ทางทะเล)',
  portOfDischargeAirport: 'ท่าขนถ่ายสินค้า(ทางอากาศ)',
  portOfDischargeSeaport: 'ท่าขนถ่ายสินค้า(ทางทะเล)',
  portOfLoading: 'ท่าเริ่มต้น',
  portOfLoadingAirport: 'ท่าเริ่มต้น(ทางอากาศ)',
  portOfLoadingSeaport: 'ท่าเริ่มต้น(ทางทะเล)',
  portOfTransfer: 'ท่าเชื่อมต่อ',
  print: 'พิมพ์',
  quantity: 'จำนวน',
  query: 'ค้นหา',
  receipt: 'การรับเงิน',
  receiptDate: 'วันที่รับเงิน',
  receivables: 'ลูกหนี้',
  receivablesWriteOfStatus: 'สถานะการตัดหนี้',
  relatedJob: 'เลขที่อ้างอิงการติดต่อ',
  remarks: 'หมายเหตุ',
  purpose: 'วัตถุประสงค์',
  postscript: 'ข้อความประกอบการทำธุรกรรม',
  preRemarks: 'หมายเหตุการรับ/จ่ายล่วงหน้า',
  ticketNo: 'เลขที่ใบเสร็จ',
  workflowNo: 'เลขที่กระบวนการ',
  removeCharge: 'ลบค่าใช้จ่าย',
  return: 'คืนเงิน',
  sales: 'การขาย',
  save: 'บันทึก',
  saveAndAdd: 'บันทึกและเพิ่มใหม่',
  separateNumber: 'เลขที่ใบแยก',
  settleAccountsTo: 'ผู้เกี่ยวข้องในการชำระเงิน',
  settlementAgent: 'ตัวแทนชำระเงิน',
  settlementCompany: 'หน่วยงานชำระเงิน',
  customerChineseName: 'ชื่อหน่วยงานผู้ว่าจ้าง (ภาษาจีน)',
  settlementType: 'ประเภทการชำระเงิน',
  solicitationType: 'ประเภทการรับสินค้า',
  status: 'สถานะ',
  submit: 'ส่ง',
  taxAmount: 'ภาษี',
  taxExcludedPrice: 'ราคาไม่รวมภาษี',
  taxIncludedPrice: 'ราคารวมภาษี',
  taxRate: 'อัตราภาษี',
  theAmountOfWriteOffs: 'จำนวนเงินที่ตัดหนี้',
  currencyAmountOfWriteOffs: 'รวมจำนวนเงินที่ตัดหนี้แยกตามสกุลเงิน',
  total: 'รวม',
  totalCurrency: 'รวมแยกตามสกุลเงิน',
  totalWriteOffs: 'รวมการตัดหนี้',
  trustFromJob: 'เลขที่อ้างอิงผู้ว่าจ้าง',
  uncheck: 'ยกเลิกการเลือก',
  unit: 'หน่วย',
  unitPrice: 'ราคาต่อหน่วย',
  unpaid: 'ยังชำระไม่ครบ',
  vessel: 'ชื่อเรือ',
  vesselAndVoyage: 'ชื่อเรือและเที่ยวบิน',
  viewDetails: 'ดูรายละเอียด',
  viewWriteOffList: 'ดูรายละเอียดการตัดหนี้',
  voyage: 'เที่ยวบิน',
  warehouseNo: 'เลขที่เข้าโกดัง',
  writeOffCurrency: 'สกุลเงินที่ตัดหนี้',
  writeOffDate: 'วันที่ตัดหนี้',
  writeOffExchangeRate: 'อัตราแลกเปลี่ยนที่ตัดหนี้',
  writeOffList: 'รายละเอียดการตัดหนี้',
  writeOffSerialNumber: 'เลขที่ลำดับการตัดหนี้',
  wroteOffOrNot: 'ได้ทำการตัดจ่ายแล้วหรือไม่',
  approveHistoryNode: 'ขั้นตอนการอนุมัติ',
  invoice_voucherDate: 'วันที่เอกสาร 2',
  time: 'เวลา',
  approveTime: 'เวลาอนุมัติ',
  operator: 'ผู้ดำเนินการ',
  approval_results: 'ผลการอนุมัติ',
  applicationDepartment: 'หน่วยงานที่ขอ',
  settleDepartmentPrefix: 'หน่วยงานการชำระเงิน',
  writeOffStatus: 'สถานะการตัดจ่าย',
  moneyWriteOffStatus: 'สถานะการตัดจ่ายค่าใช้จ่าย',
  sendWeaver: 'ส่งไปยังแพลตฟอร์มคลาวด์',
  receivablesAndPayables: 'รับ-จ่าย',
  operationDate: 'วันที่ดำเนินการ',
  newPaymentRequest_SR: 'สร้างคำขอชำระเงิน',
  deletePaymentRequest_SR: 'ลบคำขอ',
  sendWeaver_SR: 'ส่งไปยังแพลตฟอร์มคลาวด์',
  viewDetails_SR: 'ดู',
  lastInvoicingDate: 'วันที่ออกใบแจ้งหนี้ล่าสุด',
  paymentRequestState: 'สถานะคำขอชำระเงิน',
  Cargo_ApplicantPassTips: 'ยอมรับคำขอชำระเงินนี้หรือไม่',
  Cargo_ApplicantReturnToSubmitterTips: 'คำขอนี้จะถูกส่งกลับไปยังผู้ยื่นขอ ยืนยันการส่งกลับหรือไม่',
  Cargo_ApplicantReturnToBusinessTips: 'คำขอนี้จะถูกส่งกลับไปยังผู้อนุมัติทางธุรกิจ ยืนยันการส่งกลับหรือไม่',
  Cargo_ApplicantReturnToFinancialTips: 'คำขอนี้จะถูกส่งกลับไปยังผู้อนุมัติทางการเงิน ยืนยันการส่งกลับหรือไม่',
  approveReason: 'กรุณากรอกเหตุผลในการอนุมัติ',
  returnReason: 'กรุณากรอกเหตุผลในการส่งกลับ',
  bdApproveState: 'สถานะการอนุมัติทางธุรกิจ',
  ccApproveState: 'สถานะการอนุมัติทางการเงิน',
  finApproveState: 'สถานะการอนุมัติขั้นสุดท้าย',
  receiptPaymentNo: 'เลขที่เอกสารรับ-จ่าย'
}
